<p-toast position="top-right" />
<p-confirmdialog />

@if (true === isDevelopment) {
  <div class="noprint pointer-events-none fixed inset-x-0 top-0 z-50 h-10 bg-ora px-4 py-2 text-center text-base font-semibold text-white shadow">
    Ambiente di sviluppo
  </div>
}

<div class="print:pt-0" [class.development-content]="true === isDevelopment" [class.pt-10]="true === isDevelopment">
  <router-outlet />
</div>
